import type { StaticFilterField } from "./StaticFilterField";

/** The datasets table's filter rows, in picker order. */
export const DATASET_FILTER_FIELDS = [
  { type: "string", field: "dataset_id", name: "Dataset Id" },
  { type: "string", field: "name", name: "Name" },
  { type: "string", field: "description", name: "Description" },
  { type: "date", field: "created", name: "Created" },
  { type: "identity", field: "created_by", name: "Created By" },
  { type: "date", field: "modified", name: "Modified" },
  { type: "identity", field: "modified_by", name: "Modified By" },
  { type: "set", field: "tags", name: "Tags" },
] as const satisfies readonly StaticFilterField[];
